@if (toastService.toasts().length) {
<div
  id="toast-container"
  class="fixed top-4 inset-x-4 z-[9999] flex flex-col gap-3 sm:start-auto sm:end-4 sm:w-full sm:max-w-md">
  @for (toast of toastService.toasts(); track toast.id) {
  <div class="toast-item animate-slide-in shadow-lg rounded-lg overflow-hidden">
    <div class="relative">
      <app-inline-alert
        [type]="toast.type"
        [title]="toast.title"
        [message]="toast.message" />

      <!-- Dismiss button using lib-button and lib-close-icon -->
      <lib-button
        [id]="'dismiss-toast-' + toast.id"
        btnClass="absolute top-2 end-2 p-1 rounded-full opacity-60 hover:opacity-100 transition-opacity min-w-0 h-auto bg-transparent border-none text-current hover:bg-black/5"
        (click)="toastService.dismiss(toast.id)"
        aria-label="Dismiss notification">
        <lib-close-icon slot="start-icon" class="size-4" />
      </lib-button>
    </div>
  </div>
  }
</div>
}
